<template>
  <div>
    <div class="buttonOne">
      <el-button type="primary"
                 @click="display=!display">生成报告</el-button>
    </div>
    <div>
      <el-table :data="tableData"
                style="width: 100%"
                :default-sort="{prop: 'createTime', order: 'descending'}">
        <el-table-column type="index"
                         align='center'
                         label="序号">
        </el-table-column>
        <el-table-column prop="reportName"
                         align='center'
                         label="报告名称">
        </el-table-column>
        <el-table-column prop="createTime"
                         align='center'
                         label="生成时间">
        </el-table-column>
        <el-table-column prop="address"
                         label="操作"
                         align='center'
                         fixed="right"
                         width="180px">
          <template slot-scope="scope">
            <el-button type="primary"
                       @click="del(scope.row)">删除</el-button>
            <el-button type="primary"
                       @click="preview(scope.row)">预览</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page.sync='pageNo'
                   :page-size='pageSize'
                   layout="total, prev, pager, next,jumper"
                   :total='sumCount'>
    </el-pagination>
    <Presentation v-if="display"
                  @assembly='funa'
                  @assemblyTwo='funb'
                  @assemblyThree='display=false'
                  @failureGeneration='func'></Presentation>

  </div>
</template>
<script>
import Presentation from '@/pages/wpsp/PlanningReport/Presentation.vue';

export default {
  name: '',

  components: { Presentation },

  filters: {},

  data() {
    return {
      // 当前页数
      pageNo: '1',
      // 总条目数
      sumCount: '0',
      // 每页显示条数
      pageSize: 10,
      loading: '',
      dateter: '',
      display: false,
      progress: 0,
      tableData: [],
    };
  },

  computed: {},

  watch: {},

  mounted() {
    sessionStorage.setItem('custInfo', JSON.stringify(this.$route.query.row));
    const loading = this.$loading({
      lock: true,
      text: '请稍后',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    });
    this.createDataList(loading, 1);
  },

  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      const loading = this.$loading({
        lock: true,
        text: '请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      this.createDataList(loading, 1);
    },
    funa(pdfBase64) {
      const custInfo = JSON.parse(sessionStorage.getItem('custInfo'));
      const parames = {
        data: {
          cis: custInfo.cis,
          custerName: custInfo.custName, // 客户名称
          planReport: pdfBase64, // base64,
          createUserId: JSON.parse(sessionStorage.getItem('sessionData')).workNo,
        },
      };
      this.$_post(this.$API.create, parames).then((res) => {
        this.createDataList(this.loading, 2);
      });
    },
    funb(loading) {
      this.loading = loading;
    },
    func(loading) {
      this.display = false;
      loading.close();
      this.$alert('生成失败，请刷新后重试', '提示');
    },
    createDataList(loading, i) {
      // i判断要不要提示成功，1不需要2需要
      const custInfo = JSON.parse(sessionStorage.getItem('custInfo'));
      const parames = {
        data: {
          cis: custInfo.cis,
        },
        pageMessage: {
          pageSize: this.pageSize,
          pageNo: this.pageNo,
        },
      };
      this.$_post(this.$API.createDataList, parames).then((res) => {
        console.log(res, '查询列表');
        this.sumCount = res.sumCount;
        loading.close();
        if (i === 2) {
          this.$message({
            message: '成功',
            type: 'success',
          });
        }
        if (res.errorCode === 'WPLAN0001') {
          this.tableData = [];
        } else {
          this.tableData = res.data.list;
        }
        this.display = false;
      }).catch(() => {
        loading.close();
      });
    },
    preview(v) {
      const loading = this.$loading({
        lock: true,
        text: '请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      const parames = {
        data: {
          id: v.id,
        },
      };
      this.$_post(this.$API.previewCreate, parames).then((res) => {
        console.log(res.data.info, '预览报告');
        // const Blobpdf = this.dataURLtoBlob(`data:application/pdf;base64,${res.data.info}`, v.reportName);
        // const pdfUrl = URL.createObjectURL(Blobpdf);
        // window.open(pdfUrl, '_blank');
        window.open(res.data.info, '_blank');
        loading.close();
      }).catch((res) => {
        loading.close();
      });
    },
    del(v) {
      console.log(v);
      this.$confirm(`删除后，对应的财富报告将消失，确定要删除“${v.reportName}”`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        const parames = {
          data: {
            id: v.id,
          },
        };
        this.$_post(this.$API.deletecreate, parames).then((res) => {
          this.createDataList(loading, 2);
          console.log(res, '删除报告');
        }).catch((res) => {
          loading.close();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
    },
  },
  // pdfbase64转biob
  dataURLtoBlob(dataurl) {
    const arr = dataurl.split(',');
    // 注意base64的最后面中括号和引号是不转译的
    const _arr = arr[1].substring(0, arr[1].length - 2);
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(_arr);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
      type: mime,
    });
  },
};
</script>
<style lang='scss'>
html,
body {
  width: 100%;
  height: 100%;
  min-width: 300px;
}
.buttonOne {
  margin: 20px;
  padding-right: 50px;
  text-align: right;
}
</style>
